import img1 from "../assets/gallery/Spiti/spiti1.jpg";
import img2 from "../assets/gallery/Spiti/spiti2.jpg";
import img3 from "../assets/gallery/Spiti/spiti3.jpg";
import img4 from "../assets/gallery/Spiti/spiti4.jpg";
import img5 from "../assets/gallery/Spiti/spiti5.jpg";
import img6 from "../assets/gallery/Spiti/spiti6.jpg";
import img7 from "../assets/gallery/Spiti/spiti7.jpg";
import img8 from "../assets/gallery/Spiti/spiti8.jpg";
import img9 from "../assets/gallery/Spiti/spiti9.jpg";
import img10 from "../assets/gallery/Spiti/spiti10.jpg";
import img11 from "../assets/gallery/Spiti/spiti11.jpg";
import img12 from "../assets/gallery/Spiti/spiti12.jpg";
import img13 from "../assets/gallery/Spiti/spiti13.jpg";
import img14 from "../assets/gallery/Spiti/spiti14.jpg";
import img15 from "../assets/gallery/Spiti/spiti15.jpg";
import img16 from "../assets/gallery/Spiti/spiti16.jpg";
import img17 from "../assets/gallery/Spiti/spiti17.jpg";
import img18 from "../assets/gallery/Spiti/spiti18.jpg";
import img19 from "../assets/gallery/Spiti/spiti19.jpg";
import img20 from "../assets/gallery/Spiti/spiti20.jpg";
import img21 from "../assets/gallery/Spiti/spiti21.jpg";
import img22 from "../assets/gallery/Spiti/spiti22.jpg";

const spitiGallery = [
  { img: img1, colSpan: 2, rowSpan: 2 }, // hero
  { img: img2 },
  { img: img3 },
  { img: img4, colSpan: 2 },

  { img: img5 },
  { img: img6 },
  { img: img7, rowSpan: 2 },
  { img: img8 },
  { img: img9, colSpan: 2 },

  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13, colSpan: 2 },
  { img: img14 },

  { img: img15 },
  { img: img16 },
  { img: img17 },
  { img: img18 },

  { img: img19, colSpan: 2 },
  { img: img20 },
  { img: img21 },
  { img: img22 },
];

export default spitiGallery;
